import { Component, ViewChild, OnInit, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../common/global-constants';
import { customfunctions, DataParam } from '../common/customfunctions';
import { FileToUpload } from '../file-upload/file-to-upload.model';
import { AuthorEPTModel } from './authorept-model';
import { ApiMethod } from '../apimethods/api-method';
import { Router, ActivatedRoute } from '@angular/router';
import { DataAccess } from '../common/dataaccess.service';

declare var $;

@Component({
  selector: 'app-author-ept',
  templateUrl: './author-ept.component.html',
  styleUrls: ['./author-ept.component.css']
})

/** author-ept component*/
export class AuthorEptComponent {
  /** author-ept ctor */
  static modelItem: AuthorEPTModel = new AuthorEPTModel();
  filePath: any;
  fileBase64: string = "";
  public journalEmail: string;
  public processType: string = "";
  public articleId: number = 0;
  public ViewMode: string = (localStorage.LoginType == 'apsauthorproof' ? 'Old' : 'New');
  showCorrectionModal: boolean;
  pageName: string;
  http: HttpClient;
  articleNo: string;
  constructor(private router: Router, private route: ActivatedRoute, private dataAccess: DataAccess) {

    try {
      this.pageName = this.router.url.replace("/", "").split('?')[0];
    } catch (e) {
      console.log(e);
    }
    ApiMethod.getPageConfig().subscribe(
      data => {
        AuthorEptComponent.modelItem = <AuthorEPTModel>data["AuthorEPTPage"];
        localStorage.aEID = 0;
        this.getAuthorArticleList();
      }, error => {
        console.log(error);
        ngswal("Warning !", error, "warning");
      });
  }

  ngOnInit(): void {
    ApiMethod.getBaseUrl();
    $('#divLoadData').css('height', GlobalConstants.size.height - 220);
    $('#divInstructions').css('height', GlobalConstants.size.height - 350);
    $('#divArtInfo').css('margin-top', "-40px");
  }
  _correctionConfirmation: boolean = false;
  _confirmationText1: string = ''; _confirmationText2: string = '';
  _articleInfoFontStyle: string = '';
  getAuthorArticleList(): void {
    try {

      var articleData = {
        LoginId: localStorage.aLoginID,
        ArticleNo: localStorage.artNo
      };

      ApiMethod.postMethod(AuthorEptComponent.modelItem.authorArticleListApi, articleData).subscribe(
        result => {
          let itemL = result.aArticleList;

          if (itemL.length > 0) {

            if (itemL[0].ArticleInfoFontStyle != null) {
              $('#divArtInfo').attr('style', itemL[0].ArticleInfoFontStyle);
            }

            //Correction Cofirmation available
            if (itemL[0].CorrectionConfirmation == null) {
              this._correctionConfirmation = false;
              this._confirmationText1 = '';
              this._confirmationText2 = '';
            }
            else {
              this._correctionConfirmation = itemL[0].CorrectionConfirmation;
              this._confirmationText1 = itemL[0].ConfirmationText1;
              this._confirmationText2 = itemL[0].ConfirmationText2;
            }


          }

          $('#tblArticle tbody tr').remove(); $('#tblArticleOld tbody tr').remove();
          let trSNo = 0; let _prevArticle = ''; let trProofCt = 1;
          $.each(itemL, function (e, val) {
            $('#h4pageheading').html(val.StageName + ' Proofing');
            if (trSNo == 0) {
              let id = val.ID;
              localStorage.aEID = val.ArticleID;
              var adataItem = {
                ProofId: id,
                ArticleId: localStorage.aEID,
              }
              ApiMethod.postMethod(AuthorEptComponent.modelItem.articleAuthorDetailsApi, adataItem).subscribe(
                response => {
                  let _itemL = response.aArticleItem;
                  $('#tblArticleInfo tr').remove();
                  let tr = '<tr>';
                  tr += '<td>Article ID</td><td>' + _itemL[0].ArticleNo + '</td>';
                  tr += '</tr>';
                  tr += '<tr>';
                  tr += '<td>First Author</td><td>' + localStorage.aLoginName + '</td>';
                  tr += '</tr>';
                  tr += '<tr>';
                  tr += '<td>Journal Name</td><td>' + _itemL[0].Acronym + '</td>';
                  tr += '</tr>';
                  tr += '<tr>';
                  tr += '<td>Title of Article</td><td>' + _itemL[0].ArticleTitle + '</td>';
                  tr += '</tr>';
                  tr += '<tr>';
                  tr += '<td>Received Date</td><td>' + GlobalConstants.FormatDate(_itemL[0].ReceivedDate) + '</td>';
                  tr += '</tr>';

                  //Check Proofing Data
                  if (val.ID != '0') {
                    tr += '<tr>';
                    tr += '<td>Proof Available</td><td>' + GlobalConstants.FormatDate(_itemL[0].AOReceivedDt) + '</td>';
                    tr += '</tr>';

                    tr += '<tr>';
                    if (_itemL[0].AOUploadDt == null) {
                      tr += '<td>Proof Return by Author</td><td></td>';
                    }
                    else {
                      tr += '<td>Proof Return by Author</td><td>' + GlobalConstants.FormatDate(GlobalConstants.isNullCheck(_itemL[0].AOUploadDt)) + '</td>';
                    }
                    tr += '</tr>';
                  }
                  else {
                    tr += '<tr>';
                    tr += '<td>Current Status</td><td>' + _itemL[0].ArticleStatus + '</td>';
                    tr += '</tr>';
                    tr += '<tr>';
                    tr += '<td>Tentative Proof Available</td><td>' + GlobalConstants.FormatDate(_itemL[0].ArticleStatusDate) + '</td>';
                    tr += '</tr>';
                  }

                  $('#tblArticleInfo').append(tr);
                }, error => {
                  $("#LoadingImage").hide();
                  console.log(error);
                });
            }

            //Check Proofing Stage allocated
            if (val.ID != '0') {

              let customAttrOld = 'data-artid="' + val.ArticleID + '" data-id="' + val.ID + '"  data-CorrectionInputFile="' + GlobalConstants.isNullCheck(val.CorrectionInputFile) +
                '" data-CorrectionInputInstructions="' + GlobalConstants.isNullCheck(val.CorrectionInputInstructions) + '"  data-downloadstatus="' + val.DownloadStatus + '"';

              trSNo = (e + 1);

              if (_prevArticle == val.ArticleNo.toString()) {
                trProofCt++;
              }
              else {
                trProofCt = 1;
              }
              let trOld = '<tr>';
              trOld += '<td>' + trSNo + '</td>';
              trOld += '<td>' + val.ArticleNo.toString() + '</td>';
              trOld += '<td>Proof ' + trProofCt.toString() + '</td>';

              _prevArticle = val.ArticleNo.toString();

              trOld += '<td style="text-align:center"><i class="bx bx-download stageDownload" style="font-size:20px; color:#556ee6;" title="Download" ' + customAttrOld + ' ></i>&nbsp; </td>';

              if (val.IsNoCorrection != true) {
                if (val.ProofSubmitDate == null) {
                  if (val.IsOneReviewIcon == true) {
                    trOld += '<td style="text-align:center"><i class="bx bx-repeat Correction" style="font-size:20px; color:#556ee6;" title="One more review" data-onemore="Yes" ' + customAttrOld + '></i>&nbsp;<i class="bx bx-info-circle" style="font-size:20px;" title="Please click this box if you need to review another proof before publication."></i></td>';
                  }
                  else {
                    trOld += '<td></td>';
                  }
                  trOld += '<td style="text-align:center"><i class="bx bx-edit Correction" style="font-size:20px; color:Red;" title="Correction" data-onemore="No" ' + customAttrOld + '></i>&nbsp;<i class="bx bx-info-circle" style="font-size:20px;" title="Upload correction file"></i></td>';
                  if (val.ApproveAction) {
                    trOld += '<td style="text-align:center"><i class="bx bx-check Approve" style="font-size:20px; color:Green;" title="No correction" ' + customAttrOld + '></i>&nbsp;<i class="bx bx-info-circle" style="font-size:20px;" title="Please click this box if there are no corrections to the proof."></i></td>';//
                  }
                }
              }
              if (val.IsNoCorrection != true) {
                if (val.ProofSubmitDate == null && val.DownloadStatus == 'No') {
                  trOld += '<td style="text-align:center">Yet to Start</td>';
                }
                else if (val.ProofSubmitDate == null && val.DownloadStatus == 'Yes') {
                  trOld += '<td style="text-align:center">WIP</td>';
                }
                else {
                  trOld += '<td></td><td style="text-align:center"><i class="bx bx-download CorrectionDownload" style="font-size:20px; color:Red;" title="Correction" ' + customAttrOld + '></i><i class="bx bx-info-circle" style="font-size:20px;" title="Download Correction File."></i></td><td></td><td style="text-align:center">Corrections Uploaded</td>';
                }
              }
              else {
                trOld += '<td></td><td></td><td></td><td style="text-align:center">Approved</td>';
              }
              trOld += '</tr>';
              $('#tblArticleOld tbody').append(trOld);


              trSNo = (e + 1);
              let tr = '<tr>';
              tr += '<td>' + trSNo + '</td>';
              tr += '<td>' + val.ArticleNo.toString() + '</td>';
              tr += '<td>' + val.ArticleTitle.toString() + '</td>';
              tr += '<td>' + val.Journal.toString() + '</td>';

              if (val.IsNoCorrection != true) {
                if (val.ProofSubmitDate == null && val.DownloadStatus == 'No') {
                  tr += '<td style="text-align:center">Yet to Start</td>';
                }
                else if (val.ProofSubmitDate == null && val.DownloadStatus == 'Yes') {
                  tr += '<td style="text-align:center">WIP</td>';
                }
                else {
                  tr += '<td style="text-align:center">Corrections Uploaded</td>';
                }
              }
              else {
                tr += '<td style="text-align:center">Approved</td>';
              }

              let customAttr = 'data-artid="' + val.ArticleID + '" data-id="' + val.ID + '"  data-CorrectionInputFile="' + GlobalConstants.isNullCheck(val.CorrectionInputFile) +
                '" data-CorrectionInputInstructions="' + GlobalConstants.isNullCheck(val.CorrectionInputInstructions) + '"  data-downloadstatus="' + val.DownloadStatus + '"';

              tr += '<td style="text-align:center"><i class="bx bx-info-circle articleInfo" style="font-size:20px; color:#556ee6;" title="Info" ' + customAttr + ' ></i>&nbsp;</td>';

              tr += '<td style="text-align:center"><i class="bx bx-download stageDownload" style="font-size:20px; color:#556ee6;" title="Download" ' + customAttr + ' ></i>&nbsp;';

              if (val.IsNoCorrection != true) {
                if (val.ProofSubmitDate == null) {
                  if (val.IsOneReviewIcon == true) {
                    tr += '<i class="bx bx-repeat Correction" style="font-size:20px; color:#556ee6;" title="One more review" data-onemore="Yes" ' + customAttr + '></i>&nbsp;';
                  }

                  tr += '<i class="bx bx-edit Correction" style="font-size:20px; color:Red;" title="Correction" data-onemore="No" ' + customAttr + '></i>&nbsp;';
                  if (val.ApproveAction) {
                    tr += '<i class="bx bx-check Approve" style="font-size:20px; color:Green;" title="No correction" ' + customAttr + '></i>&nbsp;';
                  }
                }
                else {
                  tr += '<i class="bx bx-download CorrectionDownload" style="font-size:20px; color:Red;" title="Correction" ' + customAttr + '></i>&nbsp;';
                }
                tr += '</td>';
              }
              else {
                tr += '</td>';
              }
              tr += '</tr>';
              $('#tblArticle tbody').append(tr);

              $('#aprdEmail').attr('href', val.ProductionEmail);
              $('#aprdEmail').html(val.ProductionEmail);

            }

            //Dynamic Instruction load
            var _InstructionTitle = GlobalConstants.isNullCheck(val.InstructionTitle);
            var _InstructionItem = GlobalConstants.isNullCheck(val.InstructionItem);
            if (_InstructionTitle != '' && _InstructionItem != '') {
              $('#divInstructions').html(_InstructionTitle + _InstructionItem);
            }


          });

          $('.stageDownload').click(function () {
            try {
              let artId = $(this).attr('data-artid');
              let id = $(this).attr('data-id');
              ApiMethod.Downloadfile(AuthorEptComponent.modelItem.authorDownloadFileApi + '/' + artId + '/' + localStorage.aLoginID + '/' + id);
              $('i[data-id="' + id + '"].Correction').attr('data-downloadstatus', 'Yes');
              $('i[data-id="' + id + '"].Approve').attr('data-downloadstatus', 'Yes');
            }
            catch (e) {
              console.log(e);
            }
          });

          $('.CorrectionDownload').click(function () {
            try {
              let artId = $(this).attr('data-artid');
              let id = $(this).attr('data-id');
              ApiMethod.Downloadfile(AuthorEptComponent.modelItem.authorCorrectionDownloadFileApi + '/' + artId + '/' + localStorage.aLoginID + '/' + id);
            }
            catch (e) {
              console.log(e);
            }
          });

          $('.articleInfo').click(function () {

            try {
              let id = $(this).attr('data-id');
              localStorage.aEID = $(this).attr('data-artid');
              var adataItem = {
                ProofId: id,
                ArticleId: localStorage.aEID,
              }
              ApiMethod.postMethod(AuthorEptComponent.modelItem.articleAuthorDetailsApi, adataItem).subscribe(
                response => {
                  let _itemL = response.aArticleItem;
                  $('#tblMain tr').remove();
                  let tr = '<tr>';
                  tr += '<td>Article ID</td><td>' + _itemL[0].ArticleNo + '</td>';
                  tr += '</tr>';
                  tr += '<tr>';
                  tr += '<td>First Author</td><td>' + localStorage.aLoginName + '</td>';
                  tr += '</tr>';
                  tr += '<tr>';
                  tr += '<td>Journal Name</td><td>' + _itemL[0].Acronym + '</td>';
                  tr += '</tr>';
                  tr += '<tr>';
                  tr += '<td>Title of Article</td><td>' + _itemL[0].ArticleTitle + '</td>';
                  tr += '</tr>';
                  tr += '<tr>';
                  tr += '<td>Received Date</td><td>' + GlobalConstants.FormatDate(_itemL[0].ReceivedDate) + '</td>';
                  tr += '</tr>';
                  tr += '<tr>';
                  tr += '<td>Proof Available</td><td>' + GlobalConstants.FormatDate(_itemL[0].AOReceivedDt) + '</td>';
                  tr += '</tr>';
                  tr += '<tr>';
                  if (_itemL[0].AOUploadDt == null) {
                    tr += '<td>Proof Return</td><td>' + GlobalConstants.FormatDate(GlobalConstants.isNullCheck(_itemL[0].ArticleStatusDate)) + '</td>';
                  }
                  else {
                    tr += '<td>Proof Return</td><td>' + GlobalConstants.FormatDate(GlobalConstants.isNullCheck(_itemL[0].AOUploadDt)) + '</td>';
                  }
                  tr += '</tr>';
                  $('#tblMain').append(tr);
                  $('#myModal_Info').show();
                  $("#LoadingImage").hide();
                }, error => {
                  $("#LoadingImage").hide();
                  console.log(error);
                });
            }
            catch (e) {
              console.log(e);
            }
          });

          $('.Correction').click(function () {
            try {


              $('#TxtInstruction').val(''); $('#FU_Attchment').val('');
              let dwStatus = $(this).attr('data-downloadStatus');
              let blnOneMore = $(this).attr('data-onemore');
              localStorage.aEID = $(this).attr('data-artid');
              localStorage.ID = $(this).attr('data-id');
              if (blnOneMore == "Yes") {
                localStorage.processType = "OneMoreReview";
              }
              else {
                localStorage.processType = "";
              }

              if (dwStatus != 'Yes') {
                ngswal("Warning", "Please download the file to book a correction !", "warning");
              }
              else {
                try {
                  if ($(this).attr('data-CorrectionInputFile').toString() == "false") {
                    var el = document.getElementsByClassName('CorrectionInputFile');
                    el[0].remove();
                  }
                  if ($(this).attr('data-CorrectionInputInstructions').toString() == "false") {
                    var el = document.getElementsByClassName('CorrectionInputInstructions');
                    el[0].remove();
                  }
                } catch (e) {

                }
                $('#myModal_Corrections').show();
              }
            } catch (e) {
              console.log(e);
            }
          });

          $('.Approve').click(function () {

            try {

              $('#TxtInstruction').val('');
              let dwStatus = $(this).attr('data-downloadstatus');
              localStorage.aEID = $(this).attr('data-artid');
              localStorage.ID = $(this).attr('data-id');
              if (dwStatus != 'Yes') {
                ngswal("Warning", "Please download the file to approve the article !", "warning");
              }
              else {
                ngswal({
                  title: "Are you sure to approve the article? ",
                  text: "Article Approve Confirmation !",
                  type: "info",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No",
                  closeOnConfirm: false,
                  closeOnCancel: false
                },
                  function (isConfirm) {
                    if (isConfirm) {
                      ngswal({
                        title: 'Please wait processing!.....',
                        text: '',
                        showCancelButton: false,
                        showConfirmButton: false
                      });
                      $('#btnApprove').trigger("click");
                    } else {
                      ngswal("Cancelled", "You clicked cancel! :)", "warning");
                    }
                  });
              }

            } catch (e) {
              console.log(e);
            }
          });

          $("#LoadingImage").hide();
        }, error => {
          $("#LoadingImage").hide();
          console.log(error);
          ngswal("Failed !", error, "warning");
        });
    } catch (e) {
      console.log(e);
    }
  }

  fileChangeEvent(fileInput: any) {
    if (fileInput.currentTarget.files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.fileBase64 = e.currentTarget.result;
      }
      fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
    }
  }

  hideCorrectionModal() {
    $('#myModal_Corrections').hide();
  }

  hideInfoModal() {
    $('#myModal_Info').hide();
  }

  CorrectionConfirm() {

    if (this._correctionConfirmation == false) {
      $('#btnPMCorrections').trigger("click");
    }
    else {
      let idInput = (<HTMLInputElement>document.getElementById('FU_Attchment')).files;

      let _instructionContent = '';
      let _instruction = $('#TxtInstruction').length;

      if (_instruction > 0) {
        _instructionContent = $('#TxtInstruction').val().trim();
      }
      if (idInput.length == 0 && _instruction == 0) {
        ngswal("Warning !", "Please upload a marked-up file to proceed with the correction !", "warning");
      }
      else if (idInput.length == 0 && _instructionContent == '') {
        ngswal("Warning !", "Please enter instructions or enter instructions to proceed with the correction !", "warning");
      }
      else {
        let _text1 = this._confirmationText1;
        let _text2 = this._confirmationText2;
        ngswal({
          title: _text1,
          text: _text2,
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Ok",
          cancelButtonText: "Cancel",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              ngswal({
                title: 'Please wait processing!.....',
                text: '',
                showCancelButton: false,
                showConfirmButton: false
              });
              $('#btnPMCorrections').trigger("click");
            } else {
              ngswal("Cancelled", "You clicked cancel! :)", "warning");
            }
          });
      }

    }

  }

  updateArticleCorrection() {

    let idInput = (<HTMLInputElement>document.getElementById('FU_Attchment')).files;

    let _instructionContent = '';
    let _instruction = $('#TxtInstruction').length;

    if (_instruction > 0) {
      _instructionContent = $('#TxtInstruction').val().trim();
    }

    if (idInput.length == 0 && _instruction == 0) {
      ngswal("Warning !", "Please upload a marked-up file to proceed with the correction !", "warning");
    }
    else if (idInput.length == 0 && _instructionContent == '') {
      ngswal("Warning !", "Please enter instructions or enter instructions to proceed with the correction !", "warning");
    }
    else {
      $("#LoadingImagePopup1").show();
      this.filePath = null;
      if (idInput.length > 0) {
        this.filePath = idInput.item[0];
      }
      let file = new FileToUpload();

      if (idInput.length > 0) {
        file.fileName = idInput[0].name;
        file.fileSize = idInput[0].size;
      }
      else {
        file.fileName = "";
        file.fileSize = 0;
      }
      file.vendorConfigID = localStorage.ID;
      file.loginID = localStorage.aLoginID;
      file.publisherID = localStorage.aPubID;
      file.processType = localStorage.processType;
      file.ArticleID = localStorage.aEID;
      file.entryType = "";
      file.instruction = _instructionContent;
      file.fileAsBase64 = this.fileBase64;
      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });
      ApiMethod.postMethod(AuthorEptComponent.modelItem.authorCorrectionApi, file).subscribe(
        resonse => {
          $("#myModal_Corrections").hide();
          if (resonse.status == "Failed") {
            ngswal({
              position: "top-end",
              type: "error",
              title: "Error!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          } else {
            ngswal({
              position: "top-end",
              type: "success",
              title: "Uploaded!",
              text: resonse.message,
              showConfirmButton: false,
              timer: 1500
            });
          }
          this.getAuthorArticleList();
          $("#LoadingImagePopup1").hide();
        },
        error => {
          console.log(error);
          ngswal("Failed !", error, "warning");
          $("#LoadingImagePopup1").hide();
        }
      );

    }

  }

  approveConfirm() {
    try {
      var aItemL = {
        LoginId: localStorage.aLoginID,
        ArticleId: localStorage.aEID,
        ProofId: localStorage.ID
      }
      ApiMethod.postMethod(AuthorEptComponent.modelItem.authorApproveApi, aItemL).subscribe(
        result => {
          $("#LoadingImage").hide();
          if (result.status) {
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Approved !",
              text: result.message,
              showConfirmButton: false,
              timer: 1500
            });
            this.getAuthorArticleList();
          }
          else {
            ngswal("Failed !", result.message, "warning");
          }

        }, error => {
          $("#LoadingImage").hide();
          console.log(error);
          ngswal("Failed !", error, "warning");
        });

    } catch (e) {
      console.log(e);
    }
  }

}
